<template>
    <div class="soft-competences">
        <div class="grid">
            <div class="line"
                v-for="(item, index) in getCompetenceLevels"
                 :key="index"
            ></div>
        </div>
        <div
            v-for="(item, index) in competences"
            :key="index"
            class="competence-and-curve"
            :style="{ height: 48 * getCompetenceLevels.length + 'px' }"
        >
            <SoftCompetenceItem
                :competence="item"
                :class="{ firstMargin: index === 0, lastMargin: index === competences.length -1 }"
            />
            <SoftCompetenceCurve
                v-if="index < competences.length - 1"
                :prevCompetenceLevel = "calcLevelForCurve(
                    item.competenceLevel,
                    item.requiredLevel,
                )"
                :nextCompetenceLevel = "calcLevelForCurve(
                    competences[index + 1].competenceLevel,
                    competences[index + 1].requiredLevel,
                )"
            />
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const trackGetters = [
    'getCompetenceLevels',
];

import SoftCompetenceItem from './SoftCompetenceItem';
import SoftCompetenceCurve from './SoftCompetenceCurve';

export default {
    name: 'SoftCompetences',
    components: {
        SoftCompetenceItem,
        SoftCompetenceCurve,
    },
    props: {
        competences: Array,
    },
    computed: {
        ...mapGetters('accountTrack', trackGetters),
    },
    methods: {
        calcLevelForCurve(cLevel, rLevel) {
            let cIndex = this.getCompetenceLevels.findIndex(v => v.key === cLevel);
            let rIndex = this.getCompetenceLevels.findIndex(v => v.key === rLevel);
            let max = Math.max(cIndex, rIndex);
            return this.getCompetenceLevels[max].key;
        },
    },
};
</script>

<style lang="scss" scoped>
.soft-competences{
    display: flex;
    flex-direction: row;
    align-items: stretch;
    margin-top: 77px;
    position: relative;
    .competence-and-curve{
        display: flex;
        flex-direction: row;
        align-items: stretch;
        z-index: 2;

        .firstMargin{
            margin-left: 37px;
        }
        .lastMargin{
            margin-right: 37px;
        }
    }
    .grid{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 1;
        .line{
            border-bottom: 1px solid #E3E9F0;
            margin-top: 24px;
            margin-bottom: 47px;

        }
    }
}
</style>